import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss']
})
export class PanelPaymentMethodsComponent implements OnInit {
  
  constructor() {}

  ngOnInit(): void {
    
  }



}
